/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, OnChanges } from '@angular/core';
import { isElementNull } from '../../../../utils';

import { EAssetBatteryState } from '../../../core/models';

@Component({
  selector: 'fm-asset-battery-balloon-section',
  templateUrl: './asset-battery-balloon-section.component.html',
  styleUrls: ['./asset-battery-balloon-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssetBatteryBalloonSectionComponent implements OnChanges {
  @Input()
  remainingBatteryPercentage: number;

  roundedBatteryPercentage: number;
  batteryState: EAssetBatteryState;
  batteryReplacementHelpUrl = 'https://reveal-help.verizonconnect.com/hc/articles/360061917133';
  EAssetBatteryState = EAssetBatteryState;

  readonly LOW_BATTERY_PERCENTAGE = 10;
  readonly EMPTY_BATTERY_PERCENTAGE = 1;

  ngOnChanges(): void {
    this._setBatteryState();
    this._roundBatteryPercentage();
  }

  private _setBatteryState(): void {
    if (isElementNull(this.remainingBatteryPercentage)) {
      this.batteryState = EAssetBatteryState.Missing;
    } else if (this.remainingBatteryPercentage >= this.LOW_BATTERY_PERCENTAGE) {
      this.batteryState = EAssetBatteryState.Normal;
    } else if (this.remainingBatteryPercentage >= this.EMPTY_BATTERY_PERCENTAGE) {
      this.batteryState = EAssetBatteryState.Low;
    } else {
      this.batteryState = EAssetBatteryState.Empty;
    }
  }

  private _roundBatteryPercentage(): void {
    if (this.batteryState === EAssetBatteryState.Missing) {
      return;
    }

    this.roundedBatteryPercentage = this.batteryState === EAssetBatteryState.Empty ? 0 : Math.ceil(this.remainingBatteryPercentage);
  }
}
